// Shared stub action for commands wired into commander but not yet implemented.
// Prints a consistent message + exit code so users know it's coming.
import { chalk } from "./terminal-logger.js";

export function notImplementedYet(commandName: string, milestone?: string): () => void {
  return () => {
    process.stdout.write(
      `${chalk.yellow("⏳")} ${chalk.bold(`avatar ${commandName}`)} — chưa implement ở milestone hiện tại.\n`,
    );
    if (milestone) {
      process.stdout.write(`   Dự kiến: ${chalk.cyan(milestone)}\n`);
    }
    process.exit(0);
  };
}
